import { useSelector } from "react-redux";
import { RootModel } from "models/app";

export function useUserRecentSearches() {
    const recent = useSelector((root: RootModel) => root.user.recentSearches);
    return recent;
}
